<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#supplier" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Proveedor</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
            Editar Cuenta
          </h2>
        </div>
        <form @submit.prevent="updateEditSupplier">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-12">
            <label>Razon Social*</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.social_reason" required>
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Nit*</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.nit" required>
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Contacto</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.contact">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Pais</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.country">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Ciudad</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.city">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Direccion</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.address">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Telefono fijo</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.telphone">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Celular</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.cellphone">
          </div>
          <div class="col-span-12 sm:col-span-6">
            <label>Email</label>
            <input type="email" class="input w-full border mt-2 flex-1" v-model="supplier_current.email">
          </div>
          <div class="col-span-12 sm:col-span-12">
            <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
              <h3 class="font-medium text-base mr-auto">
                Contacto Adicional
              </h3>
            </div>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Nombre</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.contact_name">
          </div>
          <div class="col-span-6 sm:col-span-6">
            <label>Celular</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.contact_cellphone">
          </div>
          <div class="col-span-6 sm:col-span-6">
            <label>Email</label>
            <input type="email" class="input w-full border mt-2 flex-1" v-model="supplier_current.contact_email">
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Link</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier_current.link">
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button type="button" @click="closeEditSupplier()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
          <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">RAZON SOCIAL</th>
              <th class="text-center whitespace-no-wrap">NIT</th>
              <th class="text-center whitespace-no-wrap">CORREO ELECTRONICO</th>
              <th class="text-center whitespace-no-wrap">PAIS</th>
              <th class="text-center whitespace-no-wrap">URL</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="supplier in suppliers" :key="`supplier-${supplier.id}`">
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{supplier.social_reason}}</div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{supplier.nit}}</div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{supplier.email}}</div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{supplier.country}}</div>
              </td>
              <td class="w-40 text-center">
                <a :href="supplier.link" class="font-medium whitespace-no-wrap" target="_blank" v-if="supplier.link">link</a>
              </td>
              <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <router-link :to="`/admin/business/suppliers/relations/${supplier.id}`" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                      <app-icon name="folder" classname="w-4 h-4 mr-2"></app-icon>Razones
                    </router-link>
                    <button @click="editSupplier(supplier)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                      <app-icon name="edit" classname="w-4 h-4 mr-2"></app-icon>
                    </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <!-- Modal -->
    <div class="modal" id="supplier">
      <div class="modal__content">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">Crear Proveedor</h2>
        </div>
        <form @submit.prevent="createSupplier" enctype="multipart/form-data" class="form-task">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Razon Social*</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.social_reason" required>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Nit*</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.nit" required>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Contacto</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.contact">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Pais</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.country">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Ciudad</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.city">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Direccion</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.address">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Telefono fijo</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.telphone">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Celular</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.cellphone">
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Email</label>
              <input type="email" class="input w-full border mt-2 flex-1" v-model="supplier.email">
            </div>
            <div class="col-span-12 sm:col-span-12">
              <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
                <h3 class="font-medium text-base mr-auto">
                  Contacto Adicional
                </h3>
              </div>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Nombre</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.contact_name">
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Celular</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.contact_cellphone">
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Email</label>
              <input type="email" class="input w-full border mt-2 flex-1" v-model="supplier.contact_email">
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Link</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="supplier.link">
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'

  export default {
    name: 'AdminListTask',
    data () {
      return {
        loading: false,
        boxedit: false,
        supplier: this.defineSupplier(),
        supplier_current: {}
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        suppliers: 'getSuppliers',
        countries: 'getAccountCountries',
        accounts: 'getAccounts'
      }),
    },
    mounted() {
      $('#supplier').on('hidden.bs.modal', () => { this.defineSupplier() })
    },
    async beforeMount () {
      try {
        await this.getAll('supplier')
        await this.getList('accountcountry')
        await this.getList('account')

        this.loading = true
      } catch (error) {}
    },
    methods: {
      defineSupplier() {
        return {
          social_reason: null,
          contact: null,
          nit: null,
          country: null,
          city: null,
          address: null,
          telphone: null,
          cellphone: null,
          email: null,
          contact_name: null,
          contact_cellphone: null,
          contact_email: null,
          link: null,
          entity: 'supplier',
        }
      },
      createSupplier() {
        var vm = this
        window.$('#create').button('loading')
        vm.store(vm.supplier).then(item => {
          window.$('#supplier').modal('hide')
          vm.$router.replace(vm.$route.query.redirect || '/admin/business/suppliers')
        })
        .catch(error => {
          console.log('FAILURE!!');
        })
        .finally(() => {
          window.$('#create').button('reset')
          vm.loading = true
          this.supplier = this.defineSupplier()
        });
      },
      editSupplier(value) {
        this.boxedit = true
        this.supplier_current = JSON.parse(JSON.stringify(value))
      },
      closeEditSupplier() {
        this.boxedit = false
        this.supplier_current = {}
      },
      updateEditSupplier(value) {
        let vm = this
        vm.supplier_current.entity = 'supplier';
        vm.loading = false
        vm.update(vm.supplier_current).then(item => {
          vm.loading = true
          vm.boxedit = false
          vm.supplier = this.defineSupplier()
          vm.$router.replace(vm.$route.query.redirect || '/admin/business/suppliers')
        })
        .catch(message => {
          vm.loading = true
        })
      },
      ...mapActions([
        'getAll',
        'getList',
        'store',
        'update'
      ])
    },
    components: {
      appIcon: Icon,
      appLoading: Loading
    },
  }
</script>



// WEBPACK FOOTER //
// ListSuppliers.vue?3079249c